module.exports = __webpack_public_path__ + "d4341ff0706e2f9415e1c1ebdb841778.jpg";